import { ReactElement } from "react";
import { IconButton, Tooltip, SxProps, Theme } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

interface RefreshIconButtonProps {
  /** Optional event parameter so callers can stopPropagation/preventDefault when the button is inside a clickable parent (e.g. rate field) */
  onClick: (e?: React.MouseEvent) => void;
  disabled?: boolean;
  disabledTooltip?: string;
  tooltip?: string;
  sx?: SxProps<Theme>;
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "default";
}

function RefreshIconButton({
  onClick,
  disabled = false,
  disabledTooltip,
  tooltip = "Refresh rate from API",
  sx,
  size = "small",
  color = "primary",
}: RefreshIconButtonProps): ReactElement {
  const button = (
    <IconButton
      onClick={(e) => onClick(e)}
      disabled={disabled}
      size={size}
      color={color}
      sx={sx}
    >
      <RefreshIcon fontSize={size} />
    </IconButton>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} arrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  if (tooltip && !disabled) {
    return (
      <Tooltip title={tooltip} arrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
}

export default RefreshIconButton;
